import { ref, computed } from 'vue';
import {
    listAccounts,
    createAccount,
    updateAccount,
    deleteAccount,
    sortAccountList,
    listCurrencies,
} from '@/api/accounts';
import {useRoute} from "vue-router";


export function useAccounts() {
    const route = useRoute();
    const accounts = ref([]);
    const currencies = ref([]);
    const loading = ref(false);
    
    const isSuccess = ref(false);
    const messageSuccess = ref('');
    const messageError = ref('');
    
    const page = ref( Number(route.query.page ?? 1) );
    const size = ref( Number(route.query.size ?? 3) );
    const totalPages = ref( Number(0) );
    const totalElements = ref( Number(0) );
    
    function setSuccess(msg) {
        messageSuccess.value = msg;
        isSuccess.value = true;
    }
    
    function setError(msg) {
        messageError.value = msg;
        isSuccess.value = false;
    }
    
    async function load(pageArg = 1, sizeArg = 20) {
        loading.value = true;
        try {
            const data = await listAccounts(pageArg, sizeArg);
            accounts.value = data.content;
            page.value = data.number + 1;
            size.value = data.size;
            totalPages.value = data.totalPages;
            totalElements.value = data.totalElements;
            currencies.value = await listCurrencies();
        } catch (e) {
            
            setError('Не удалось загрузить');
        } finally {
            loading.value = false;
        }
    }
    
    async function addAccount(payload) {
        try {
            await createAccount(payload);
            setSuccess('Счет добавлен');
            await load();
        } catch (e) {
            setError('Не удалось добавить счет');
        }
    }
    
    async function updateAccountById(id, payload) {
        try {
            await updateAccount(id, payload);
            setSuccess('Счет обновлен');
            await load();
        } catch (e) {
            
            setError('Не удалось обновить счет');
        }
    }
    
    async function deleteAccountById(id) {
        try {
            await deleteAccount(id);
            setSuccess('Счет удален');
            await load();
        } catch (e) {
            
            setError('Не удалось удалить счет');
        }
    }
    
    async function sortAccounts(payload) {
        try {
            await sortAccountList(payload);
            setSuccess('Сортировка обновлена');
        } catch (e) {
            
            setError('Не удалось обновить сортировку');
        }
    }
    
    async function clearAll() {
        try {
            await clearTransactions();
            setSuccess('Все счета удалены');
            await load();
        } catch (e) {
            
            setError('Не удалось очистить счета');
        }
    }
    
    return {
        accounts,
        loading,
        currencies,
        isSuccess,
        messageError,
        messageSuccess,
        page,
        size,
        totalPages,
        totalElements,
        load,
        addAccount,
        updateAccountById,
        deleteAccountById,
        sortAccounts,
    };
}
